<template>
  <div class="fixed-bottom-cart">
    <div class="h100"></div>
    <div class="fixed fixed-ios">
      <div class="tips">商品价格以实际下单界面为准</div>
      <div class="flex space-between align-center fix-content pl16 pr16">
        <div class="left flex align-center">
          <van-checkbox v-model="checkedAll" label-disabled @change="handleCheckAll"></van-checkbox>
          <div class="price-container">
            <div class="flex align-center">
              <span>合计：</span>
              <div class="price-info">
                <div class="rmb">&yen;</div>
                <div class="price-txt">{{ totalCountPrice | price }}</div>
              </div>
            </div>
            <!-- <div class="fee-info">
              <span v-if="expreeFee.firstOrders">首单已享包邮</span>
              <span v-else-if="expreeFee.freeShippingAmount - totalCountPrice > 0">
                差
                <span class="pri">{{ (expreeFee.freeShippingAmount - totalCountPrice) | parsePrice }}</span>
                享受包邮（满
                <span class="pri">{{ expreeFee.freeShippingAmount | price }}</span>
                包邮）
              </span>
              <span v-else>
                已包邮（满
                <span class="pri">{{ expreeFee.freeShippingAmount | price }}</span>
                包邮）
              </span>
            </div> -->
          </div>
        </div>
        <van-button type="primary" size="mini" class="submit_button" v-reClick="submit" :disabled="!checked.length">
          {{ retry ? '再次结算' : '去结算' }}
          <span v-if="checked.length">({{ checked.length }})</span>
        </van-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['totalCountPrice', 'checked', 'retry'],
  data() {
    return {
      checkedAll: true, // 是否全选
      expreeFee: {
        firstOrders: false,
        freeShippingAmount: 0
      }
    };
  },
  created() {
    this.fetchExpressFree(); // 获取包邮信息
  },
  methods: {
    handleCheckAll() {
      this.$emit('handleCheckAll', this.checkedAll);
    },
    async fetchExpressFree() {
      const res = await this.$fetch.fetchExpressFree();
      this.expreeFee = res;
    },
    submit() {
      this.$emit('submit');
    }
  }
};
</script>
<style lang="less" scoped>
.fixed-bottom-cart {
  ::v-deep.van-checkbox {
    overflow: visible;
  }
  .tips {
    background: #ebf8ff;
    padding: 13px 16px;
    border-bottom: 1px solid #eee;
    color: #1e8dff;
    font-size: 14px;
    line-height: 14px;
  }
  .fixed {
    position: fixed;

    bottom: 0;
    left: 0;
    width: 100%;
  }
  .h100 {
    height: 100px;
  }
  .fix-content {
    background: #fff;
    height: 60px;
  }
  .price-info {
    display: flex;
    align-items: baseline;

    .rmb {
      color: #ff4e47;
      font-size: 12px;
      transform: scale(0.9, 0.9);
      transform-origin: bottom;
      font-weight: 500;
      line-height: 1;
    }

    .price-txt {
      color: #ff4e47;
      font-size: 16px;
      line-height: 1;
      margin-right: 4px;
      font-weight: 500;
    }
  }
  .price-container {
    margin-left: 12px;

    .fee-info {
      margin-top: 4px;
      font-size: 12px;
      width: 110%;
      background: transparent;
      position: relative;
      left: -5%;
      transform: scale(0.9, 0.9);
      color: #8c8c8c;
      .pri {
        color: #f23400;
      }
    }
  }
  .left {
    font-size: 14px;
    color: #333;
    .price {
      font-size: 16px;
      font-weight: 500;
      color: #f23400;
    }
  }
  .submit_button {
    padding: 0 !important;
    width: 125px;
    height: 44px;
    font-size: 16px;
    border-radius: 8px;
  }
}
</style>
